// extracted by mini-css-extract-plugin
module.exports = {"profile_image":"ProfileImage_profile_image_1Iev4","img":"ProfileImage_img_S1c1H"};